import flowRight from 'lodash.flowright';
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';

import styles from '../styles/subscriptionsData';
import { isArray } from '../../../utils/isDefined';
import Problems from '../../../pages/user/components/Problems';
import DataBox from '../../../partials/dataBox/DataBox';
import Optional from '../../../utils/optional';
import { SUBSCRIPTIONS_STATUS_OPTIONS } from '../../../consts/initialValues';

const SubscriptionData = ({ classes, subscription }) => {
  return (
    <div className={classes.root}>
      {isArray(subscription?.problems) && (
        <Problems
          problems={subscription?.problems}
          customClasses={{ root: classes.problemsRoot }}
        />
      )}
      <div className={classes.nameContainer}>
        <DataBox
          label="Product"
          value={Optional(subscription?.skuTranslations?.default).or('')}
          customClasses={{ root: classes.productRoot }}
        />
        <DataBox
          label="Status"
          value={Optional(
            SUBSCRIPTIONS_STATUS_OPTIONS.find(
              option => option.value === subscription?.status
            )
          )
            .map(status => status.label)
            .or(subscription?.status)}
          customClasses={{ root: classes.productRoot }}
        />
      </div>
    </div>
  );
};

const mapStatesToProps = ({ editSimcard }) => {
  return {
    subscription: editSimcard.subscription
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(SubscriptionData);
